import { useActivityQueriesInfinite } from './useActivityQueriesInfinite'

export function useActivityQuery() {
  return {
    queryActivitiesInfinite: useActivityQueriesInfinite,
  }
}
